/* tslint:disable:jsx-no-lambda WI:47753 */
import * as React from 'react';
import getRecipientString from 'owa-readwrite-recipient-well/lib/utils/getRecipientString';
import { classNamesFunction } from '@uifabric/utilities';
import { ContactPickerPane } from 'owa-contact-picker';
import { getExtendedTheme } from 'owa-fabric-theme';
import { getStyles } from './RecipientWellLabelWithContactPicker.styles';
import { observer } from 'mobx-react';
import { RecipientType } from 'owa-recipient-common/lib/store/schema/RecipientType';
import {
    RecipientWellLabelWithContactPickerProps,
    RecipientWellLabelWithContactPickerStyleProps,
    RecipientWellLabelWithContactPickerStyles,
} from './RecipientWellLabelWithContactPicker.types';

const getClassNames = classNamesFunction<
    RecipientWellLabelWithContactPickerStyleProps,
    RecipientWellLabelWithContactPickerStyles
>();

export interface RecipientWellLabelWithContactPickerState {
    shouldShowContactPicker: boolean;
}

@observer
export default class RecipientWellLabelWithContactPicker extends React.Component<
    RecipientWellLabelWithContactPickerProps,
    RecipientWellLabelWithContactPickerState
> {
    private contactPickerButton: HTMLElement;

    constructor(props: RecipientWellLabelWithContactPickerProps) {
        super(props);

        this.state = {
            shouldShowContactPicker: false,
        };
    }
    render() {
        let { recipientType, addRecipient, theme = getExtendedTheme() } = this.props;
        const classNames = getClassNames(getStyles, { theme: theme });
        let wellLabel =
            recipientType != RecipientType.None ? (
                <div
                    data-is-focusable={true}
                    tabIndex={0}
                    onClick={() =>
                        this.setState({
                            shouldShowContactPicker: !this.state.shouldShowContactPicker,
                        })
                    }
                    className={classNames.label}>
                    {getRecipientString(recipientType)}
                </div>
            ) : null;
        return (
            <div ref={this.bindContactPickerRef} className={classNames.root}>
                {wellLabel}
                {this.state.shouldShowContactPicker && (
                    <ContactPickerPane
                        findControlGetter={this.getContactPickerButton}
                        dismissContactPickerAction={() =>
                            this.setState({ shouldShowContactPicker: false })
                        }
                        addRecipientAction={addRecipient}
                        theme={theme}
                    />
                )}
            </div>
        );
    }

    private bindContactPickerRef = (ref: HTMLElement) => {
        if (ref != null) {
            this.contactPickerButton = ref;
        }
    };

    private getContactPickerButton = () => {
        return this.contactPickerButton;
    };
}
